import { render, staticRenderFns } from "./FormularioWeb.vue?vue&type=template&id=65a73482&scoped=true"
import script from "./FormularioWeb.vue?vue&type=script&lang=js"
export * from "./FormularioWeb.vue?vue&type=script&lang=js"
import style0 from "./FormularioWeb.vue?vue&type=style&index=0&id=65a73482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a73482",
  null
  
)

export default component.exports